import { CHApiResultState, LoadingState } from "@app/root-store/api-result.state";
import { createReducer, on } from "@ngrx/store";

import { CHZone } from "@app/area/model/ch-zone";
import { ZoneActions } from "@app/area/store/actions";
import { initialZoneState } from "@app/project/store/clarehome.state";
import { ClareHomeDbCollection } from "@app/shared/resources/resource-objectifier";

export type ZoneState = CHApiResultState<ClareHomeDbCollection<CHZone>>;

export const zoneReducers = createReducer(
    initialZoneState(),
    on(ZoneActions.clear, (): ZoneState => initialZoneState()),
    on(
        ZoneActions.load,
        (state, { uuid }): ZoneState => ({
            ...state,
            result: null,
            uuid,
            callState: LoadingState.loading,
        })
    ),
    on(
        ZoneActions.loadSuccess,
        (state, { uuid, zones }): ZoneState => ({
            ...state,
            uuid,
            result: zones,
            callState: LoadingState.loaded,
        })
    ),
    on(
        ZoneActions.create,
        ZoneActions.update,
        ZoneActions.deleteItem,
        (state): ZoneState => ({
            ...state,
            callState: LoadingState.loading,
        })
    ),
    on(
        ZoneActions.createSuccess,
        ZoneActions.updateSuccess,
        (state, { zone }): ZoneState => ({
            ...state,
            result: {
                ...state.result,
                [zone.id]: zone,
            },
            callState: LoadingState.loaded,
        })
    ),
    on(ZoneActions.deleteSuccess, (state, { zone }): ZoneState => {
        const zones = { ...state.result };
        delete zones[zone.id];

        return {
            ...state,
            result: zones,
            callState: LoadingState.loaded,
        };
    }),
    on(
        ZoneActions.createFailure,
        ZoneActions.updateFailure,
        ZoneActions.loadFailure,
        ZoneActions.deleteFailure,
        (state, { error }): ZoneState => ({
            ...state,
            callState: error,
        })
    )
);
